import { AG_GRID_LOCALE_EN } from "@ag-grid-community/locale";

export const agGridCustomLocale = {
  ...AG_GRID_LOCALE_EN,
  rowGroupColumnsEmptyMessage: "Drag column here to set row groups",
  advancedFilterBuilder: "Filters",
  filterOoo: "Filter by value",
};
